// extracted by mini-css-extract-plugin
export var dropdownButton = "_37-0";
export var fullWidthDropdownButton = "_37-1";
export var icon = "_37-3";
export var iconPlaceholder = "_37-2";
export var shortcutContainer = "_37-4";